<form
  novalidate
  [itfgPermissions]="['USER_WRITE']"
  [formGroup]="occupationStatusForm"
  >
  <mat-card appearance="outlined">
    <mat-card-title>
      <span
        class="edit-screen-card-title"
        [translate]="'clients.occupationStatus'"
        >Occupation status</span
        >
      </mat-card-title>
      <mat-card-content>
        <div layout="row" layout-wrap layout-align="start end">
          <mat-card appearance="outlined">
            <mat-card-content
              flex="100"
              layout="row"
              layout-wrap
              layout-align="space-around center"
              >
              <div
                flex="100"
                layout="row"
                layout-wrap
                layout-align="space-around center"
                >
                <mat-form-field flex>
                  <mat-select
                    matInput
                    formControlName="employmentType"
                    placeholder="{{ 'clients.employmentType' | translate }}"
                    >
                    @for (employment of employmentType; track employment) {
                      <mat-option
                        [disabled]="['USER_WRITE'] | isUnauthorized | async"
                        [value]="employment.id"
                        >{{ employment.type }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field flex>
                  <input
                    matInput
                    type="text"
                    formControlName="workPosition"
                    placeholder="{{ 'clients.workPosition' | translate }}"
                    />
                    <mat-label>{{ 'clients.workPosition' | translate }}</mat-label>
                    @if (
                      occupationStatusForm.get('workPosition').hasError('maxlength')
                      ) {
                      <mat-error
                        [translate]="'forms.maxLength'"
                        [translateParams]="{ value: WORK_POSITION_MAX_LENGTH }"
                        >No letter
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div
                  flex="100"
                  layout="row"
                  layout-wrap
                  layout-align="space-around center"
                  >
                  <div flex="50" layout="column">
                    <div class="label-style">
                      {{ 'clients.workExperience' | translate }}
                    </div>
                    <div flex="100" layout="row" layout-align="space-around center">
                      <mat-form-field flex>
                        <input
                          matInput
                          type="number"
                          min="0"
                          formControlName="workExperienceYears"
                          placeholder="{{ 'global.years' | translate }}"
                          />
                          <mat-label>{{ 'global.years' | translate }}</mat-label>
                          @if (
                            occupationStatusForm
                            .get('workExperienceYears')
                            .hasError('max')
                            ) {
                            <mat-error
                              [translate]="'forms.maxValue'"
                              [translateParams]="{ value: WORK_EXPERIENCE_MAX_VALUE }"
                              >
                              No letter
                            </mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field flex>
                          <input
                            matInput
                            type="number"
                            min="0"
                            formControlName="workExperienceMonth"
                            placeholder="{{ 'global.months' | translate }}"
                            />
                            <mat-label>{{ 'global.months' | translate }}</mat-label>
                            @if (
                              occupationStatusForm
                              .get('workExperienceMonth')
                              .hasError('max')
                              ) {
                              <mat-error
                                [translate]="'forms.maxValue'"
                                [translateParams]="{ value: WORK_EXPERIENCE_MAX_VALUE }"
                                >
                                No letter
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                      <div flex="50" layout="column">
                        <div class="label-style">
                          {{ 'clients.workExperienceTotal' | translate }}
                        </div>
                        <div flex="100" layout="row" layout-align="space-around center">
                          <mat-form-field flex>
                            <input
                              matInput
                              type="number"
                              min="0"
                              formControlName="workExperienceTotalYears"
                              placeholder="{{ 'global.years' | translate }}"
                              />
                              <mat-label>{{ 'global.years' | translate }}</mat-label>
                              @if (
                                occupationStatusForm
                                .get('workExperienceYears')
                                .hasError('max')
                                ) {
                                <mat-error
                                  [translate]="'forms.maxValue'"
                                  [translateParams]="{ value: WORK_EXPERIENCE_MAX_VALUE }"
                                  >
                                  No letter
                                </mat-error>
                              }
                            </mat-form-field>
                            <mat-form-field flex>
                              <input
                                matInput
                                type="number"
                                min="0"
                                formControlName="workExperienceTotalMonth"
                                placeholder="{{ 'global.months' | translate }}"
                                />
                                <mat-label>{{ 'global.months' | translate }}</mat-label>
                                @if (
                                  occupationStatusForm
                                  .get('workExperienceMonth')
                                  .hasError('max')
                                  ) {
                                  <mat-error
                                    [translate]="'forms.maxValue'"
                                    [translateParams]="{ value: WORK_EXPERIENCE_MAX_VALUE }"
                                    >
                                    No letter
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div
                          flex="100"
                          layout="row"
                          layout-wrap
                          layout-align="space-around center"
                          >
                          <mat-form-field flex>
                            <input
                              matInput
                              type="text"
                              formControlName="employerName"
                              placeholder="{{ 'clients.employerName' | translate }}"
                              />
                              <mat-label>{{ 'clients.employerName' | translate }}</mat-label>
                              @if (
                                occupationStatusForm.get('employerName').hasError('maxlength')
                                ) {
                                <mat-error
                                  [translate]="'forms.maxLength'"
                                  [translateParams]="{ value: EMPLOYER_NAME_MAX_LENGTH }"
                                  >No letter
                                </mat-error>
                              }
                            </mat-form-field>
                            <mat-form-field flex>
                              <input
                                matInput
                                itfgTrimInput
                                type="text"
                                class="employer-id-input-styles"
                                formControlName="employerId"
                                placeholder="{{ 'clients.employerId' | translate }}"
                                />
                                <mat-label>{{ 'clients.employerId' | translate }}</mat-label>
                                @if (
                                  occupationStatusForm.get('employerId').hasError('maxlength')
                                  ) {
                                  <mat-error
                                    [translate]="'forms.maxLength'"
                                    [translateParams]="{ value: EMPLOYER_ID_MAX_LENGTH }"
                                    >No letter
                                  </mat-error>
                                }
                                @if (
                                  occupationStatusForm
                                  .get('employerId')
                                  .hasError('incorrectEik')
                                  ) {
                                  <mat-error [translate]="'clients.invalidemployerNumber'"
                                    >Invalid employer number
                                  </mat-error>
                                }
                                @if (!employerIdIsInBlacklist) {
                                  <button
                                    type="button"
                                    matSuffix
                                    mat-icon-button
                    [disabled]="
                      isNewItem ||
                      (['BLACKLIST_WRITE'] | isUnauthorized | async)
                    "
                                    class="input-suffix-button add-toblacklist-flag-color"
                                    (click)="addToBlacklist()"
                                    >
                                    <mat-icon
                      matTooltip="{{
                        'clients.addEmployerToBlacklist' | translate
                      }}"
                                      [matTooltipDisabled]="isNewItem"
                                      matTooltipPosition="above"
                                      >not_interested
                                    </mat-icon>
                                  </button>
                                }
                                @if (employerIdIsInBlacklist) {
                                  <button
                                    type="button"
                                    matSuffix
                                    mat-icon-button
                    [disabled]="
                      isNewItem || (['BLACKLIST_READ'] | isUnauthorized | async)
                    "
                                    class="input-suffix-button"
                                    [ngClass]="
                      employerIdBlacklistOtherBrandOnly
                        ? 'blacklisted-other-brand-flag-color'
                        : 'blacklisted-flag-color'
                    "
                                    (click)="editInBlacklist()"
                                    >
                                    <mat-icon
                      matTooltip="{{
                        'clients.editEmployerInBlacklist' | translate
                      }}{{
                        employerIdBlacklistOtherBrandOnly &&
                        employerIdBlacklistBrandCodes
                          ? ' (' + employerIdBlacklistBrandCodes + ')'
                          : ''
                      }}"
                                      [matTooltipDisabled]="isNewItem"
                                      matTooltipPosition="above"
                                      >not_interested
                                    </mat-icon>
                                  </button>
                                }
                              </mat-form-field>
                              <mat-form-field flex>
                                <mat-select
                                  matInput
                                  formControlName="education"
                                  placeholder="{{ 'clients.education' | translate }}"
                                  >
                                  @for (type of education; track type) {
                                    <mat-option
                                      [disabled]="['USER_WRITE'] | isUnauthorized | async"
                                      [value]="type.id"
                                      >{{ type.name }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div
                              flex="100"
                              layout="row"
                              layout-wrap
                              layout-align="start center"
                              >
                              <mat-form-field flex flex-gt-xs="33">
                                <input
                                  matInput
                                  type="text"
                                  formControlName="workCity"
                                  [matAutocomplete]="city"
                                  itfgSelectFirstAutocompleteOptionOnBlur
                                  placeholder="{{ 'clients.workCity' | translate }}"
                                  />
                                  <mat-label>{{ 'clients.workCity' | translate }}</mat-label>
                                  @if (
                                    occupationStatusForm.get('workCity').hasError('lacksLatin')
                                    ) {
                                    <mat-error
                                      [translate]="'forms.fieldShouldNotHaveLatinCharacters'"
                                    ></mat-error>
                                  }
                                  @if (
                                    occupationStatusForm.get('workCity').hasError('notValidCity')
                                    ) {
                                    <mat-error [translate]="'forms.notValidCity'"></mat-error>
                                  }
                                  <mat-autocomplete
                                    #city="matAutocomplete"
                                    itfgHighlightFirstAutocompleteOptionOnChange
                                    [displayWith]="mapCityToDisplayValue"
                                    >
                                    @for (city of cityList; track city) {
                                      <mat-option [value]="city">
                                        {{ city | cityDisplayText }}
                                      </mat-option>
                                    }
                                  </mat-autocomplete>
                                </mat-form-field>
                                <mat-form-field flex>
                                  <input
                                    matInput
                                    type="text"
                                    formControlName="workAddress"
                                    placeholder="{{ 'clients.workAddress' | translate }}"
                                    />
                                    <mat-label>{{ 'clients.workAddress' | translate }}</mat-label>
                                    @if (occupationStatusForm.hasError('cityRequiredForAddress')) {
                                      <mat-hint
                                        [ngStyle]="{ color: 'red' }"
                                        [translate]="'forms.addressRequiresCity'"
                                        >Address requires city
                                      </mat-hint>
                                    }
                                  </mat-form-field>
                                </div>
                              </mat-card-content>
                            </mat-card>
                            <mat-card appearance="outlined">
                              <mat-card-content>
                                <div layout="column">
                                  <mat-form-field flex="100">
                                    <mat-select
                                      matInput
                                      formControlName="bankTransferSalary"
                                      placeholder="{{ 'clients.bankTransferSalary' | translate }}"
                                      >
                                      @for (payment of paymentType; track payment) {
                                        <mat-option
                                          [disabled]="['USER_WRITE'] | isUnauthorized | async"
                                          [value]="payment.id"
                                          >{{ payment.name }}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                  <div
                                    flex="100"
                                    layout="row"
                                    layout-wrap
                                    layout-align="space-between center"
                                    >
                                    <mat-form-field flex>
                                      <input
                                        matInput
                                        type="number"
                                        min="0"
                                        step="10"
                                        formControlName="salary"
                                        placeholder="{{ 'clients.salary' | translate }}"
                                        />
                                        <mat-label>{{ 'clients.salary' | translate }}</mat-label>

                                        <span matSuffix> {{fxService.currencySymbol()}} </span>

                                        @if (
                                          occupationStatusForm.get('salary').value &&
                                          fxService.displayCurrency() === Currency.EUR
                                          ) {
                                          <mat-hint
                                            >
                                            {{
                                            occupationStatusForm.get('salary').value
                                            | toCustomItfgCurrency
                                            }}
                                          </mat-hint>
                                        }

                                        @if (occupationStatusForm.get('salary').hasError('max')) {
                                          <mat-error
                                            [translate]="'forms.maxValue'"
                                            [translateParams]="{ value: SALARY_MAX_VALUE }"
                                            >No letter
                                          </mat-error>
                                        }
                                      </mat-form-field>

                                      <mat-form-field flex>
                                        <input
                                          matInput
                                          type="number"
                                          min="0"
                                          step="10"
                                          formControlName="extraIncome"
                                          placeholder="{{ 'clients.extraIncome' | translate }}"
                                          />
                                          <mat-label>{{ 'clients.extraIncome' | translate }}</mat-label>

                                          <span matSuffix> {{fxService.currencySymbol()}} </span>

                                          @if (
                                            occupationStatusForm.get('extraIncome').value &&
                                            fxService.displayCurrency() === Currency.EUR
                                            ) {
                                            <mat-hint
                                              >
                                              {{
                                              occupationStatusForm.get('extraIncome').value
                                              | toCustomItfgCurrency
                                              }}
                                            </mat-hint>
                                          }

                                          @if (
                                            occupationStatusForm.get('extraIncome').hasError('max')
                                            ) {
                                            <mat-error
                                              [translate]="'forms.maxValue'"
                                              [translateParams]="{ value: EXTRA_INCOME_MAX_VALUE }"
                                              >No letter
                                            </mat-error>
                                          }
                                        </mat-form-field>
                                      </div>
                                      <mat-form-field flex="100">
                                        <textarea
                                          matInput
                                          cdkTextareaAutosize
                                          cdkAutosizeMaxRows="8"
                                          cdkAutosizeMinRows="3"
                                          formControlName="extraIncomeNotes"
                                          placeholder="{{ 'clients.extraIncomeNotes' | translate }}"
                                          itfgAutoScrollTextarea
                                        ></textarea>
                                      </mat-form-field>
                                    </div>
                                  </mat-card-content>
                                </mat-card>
                              </div>
                            </mat-card-content>
                          </mat-card>
                        </form>
